import { Map, Record } from "immutable";
import { AnyAction } from "redux";

import { ACTION_SUCCESS } from "@services/AsyncActionCreatorFactory";

import { subscriptionFactory } from "@app/redux/subscription/subscription.factories";
import { FETCH_SUBSCRIPTION_BY_ID } from "@app/redux/subscription/subscription.actions";
import {
  SubscriptionReducer,
  SubscriptionState,
} from "@app/redux/subscription/subscription.typings";

const initialState = Record<SubscriptionState>({
  subscriptions: Map(),
});

const subscriptionReducer = (
  store: Record<SubscriptionState> = initialState(),
  action: AnyAction,
): SubscriptionReducer => {
  const { type, payload } = action;

  switch (type) {
    case `${FETCH_SUBSCRIPTION_BY_ID}${ACTION_SUCCESS}`:
      return store.setIn(
        ["subscriptions", payload.data.uuid],
        subscriptionFactory(payload.data),
      );

    default: {
      return store;
    }
  }
};

export { subscriptionReducer };
